import noop from "lodash/noop";
export default (setInProgress) => ({
    show: () => {
        setInProgress(true);
    },
    hide: () => {
        setInProgress(false);
    },
    dispose: noop
});
